module.exports = __webpack_public_path__ + "img/2_1-industriale-fabbrica_b-1.ad042e2b.png";